<template>
  <div class="calendars">
    <div class="calendars-top">
      <div class="top-years" @click="showChangeYear = true">
        {{ year }}年
        <img src="@/assets/images/cartojourney/img27.png" class="icon" alt="" />
      </div>
      <div class="top-years">
        <img src="@/assets/images/cartojourney/img27.png" @click="handleMonthJian" class="icon icon-left" alt="" />
        {{ `${month}`.padStart(2, '0') }}月
        <img src="@/assets/images/cartojourney/img27.png" @click="handleMonthJia" class="icon icon-right" alt="" />
      </div>
    </div>
    <SimpleCalendarVue ref="calendar" :year="year" :month="month" @dayClick="handleClickDate">
      <template v-slot:day-info="{ day }">
        <div class="tags" v-if="slotDateArr[day]">
          <div v-for="(tag, index) in slotDateArr[day].slice(0, 3) || []" :key="index" class="tag-txt"
            :class="`tag-txt4 tags${tag.type}`">
            <template> {{ types[tag.type] }}</template>
          </div>
          <div v-if="slotDateArr[day] && slotDateArr[day].length - 3 > 0" class="tag-txt tags0">
            {{ slotDateArr[day].length - 3 }}
          </div>
        </div>
      </template>
      <template v-slot:more-info="{ infoIndex }">
        <div class="current-more-info" v-if="infoIndex === defaultIndex">
          <div class="more-info">
            <div class="tag-txt">清单 {{ getCurEvents().length }}</div>
            <div class="info-list">
              <div class="info-item" v-for="(item, index) in getCurEvents()" :key="index" @click="handleJump(item)">
                <div class="item-tags" :class="`tag-txt4 tags${item.type}`">
                  {{ types[item.type] }}
                </div>
                <div class="item-cons">
                  <div class="cons-txt" v-if="`${item.type}` === '6'">
                    iEP学习
                  </div>
                  <div class="cons-txt" v-else-if="`${item.type}` === '7'">
                    {{ item.classContent }}
                  </div>
                  <div class="cons-txt cons-txt-question" v-else-if="`${item.type}` === '9'">
                    自测
                    <div class="go-btn" v-track="{ functionName: '进入班级考试' }" @click="handleGoAnswer(item)">
                      进入考试
                      <!-- <img src="@/assets/images/grade" alt=""> -->
                    </div>
                  </div>
                  <template v-else-if="`${item.type}` === '10' && item.docuCourseCase.length > 0">
                    <div class="cons-txt con-txt2" v-for="(itm, idx) in item.docuCourseCase" :key="idx"
                      :class="item.docuCourseCase.length - 1 === idx ? 'cont-btm' : ''" @click="handleGoto(itm)">
                      <img src="@/assets/images/grade/icon-suo.png" v-if="`${itm.isUnlock}` === '1' && !itm.myUnlock"
                        class="icon-suo" alt="">
                      <span class="con-idx">{{ `${idx + 1}.${itm.title}` }}</span>
                      <img src="@/assets/images/grade/icon-right.png" class="itm-right" alt="">
                    </div>
                  </template>
                  <div class="cons-txt" v-else>
                    {{ item.campName || item.simulatorName || item.subjectName || item.subjectName || item.activityName }}
                  </div>
                  <div class="cons-times">
                    <template v-if="`${item.type}` !== '10'">
                      {{ `${$moment(item.startTime * 1).format('MM/DD HH:mm')}` }}
                      <span v-if="item.endTime">
                        -
                        {{ $moment(item.endTime * 1).format('MM/DD HH:mm') }}
                      </span>
                    </template>
                    <span class="class-txt">{{ item.className }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </SimpleCalendarVue>
    <van-popup v-model="showChangeYear" position="bottom" :style="{ height: '35%' }">
      <van-picker show-toolbar :default-index="colum_index" :columns="columns" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleGotoDetails" :dataProps="dataProps"></dialog-unlock>
    <dialogDel ref="dialogDel" @handleDelSave="handleDelSave" :dialogHeadTxt="dialogHeadTxt" :delMessage="delMessage"></dialogDel>
  </div>
</template>
<script>
import SimpleCalendarVue from '../../../components/SimpleCalendar.vue'
import { cardCalendar } from '@/api/grade'
import dialogUnlock from '@/components/dialogUnlock.vue'
import dialogDel from './dialogDel.vue'
import {isScorm} from '../../../api/scorm'
const formatter = (type, val) => {
  if (type === 'year') {
    return `${val}年`
  } else if (type === 'month') {
    // 隐藏月份选项
    return ''
  }
  return val
}
export default {
  data () {
    return {
      year: 0,
      month: 0,
      curDay: 0,
      defaultIndex: null,
      slotDateArr: {},
      formatter,
      types: {
        6: '学习',
        7: '答疑',
        8: '练习',
        9: '考试',
        10: '课表'
      },
      showChangeYear: false,
      columns: [],
      colum_index: 0,
      classId: '',
      isDayChanged: false,
      dataProps: {
        unlockContent: '兑换班级日历课程',
        unlockTxt: '学习日历'
      },
      delMessage: '确认删除吗?',
      dialogHeadTxt: '提示'
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  components: {
    SimpleCalendarVue,
    dialogUnlock,
    dialogDel
  },
  mounted () {
    this.classId = this.$route.query.classId
    this.year = new Date().getFullYear()
    this.month = `${new Date().getMonth() + 1}`.padStart(2, '0')
    this.curDay = `${new Date().getDate()}`.padStart(2, '0')
    this.getYearsAroundCurrentYear()
    this.handleGetfun()
  },
  methods: {
    handleJump (item) {
      let path = ''
      console.log('🚀 ~ handleJump ~ item:', item)
      if ([6, 7, 8].includes(item.type)) {
        const PATHS2 = {
          6: '/iepDetails',
          7: '/answerDetails',
          8: '/mockDetails'
        }
        path = PATHS2[item.type]
      }
      this.$router.push({
        path,
        query: {
          postId: item.id,
          classId: this.classId
        }
      })
    },

    async handleGetfun () {
      try {
        const params = {
          year: this.year,
          month: this.month,
          classId: this.classId,
          userId: this.userInfo.id,
          memberType: this.userInfo.memberType,
        }
        const res = await cardCalendar(params)
        if (res && res.data) {
          const curTimeTxt = this.formatDate(this.year, this.month, this.curDay)
          this.$refs.calendar.clickDate = curTimeTxt
          Object.values(res.data).forEach((item, index) => {
            const dateKey = this.formatDate(this.year, this.month, index + 1)
            item.forEach(event => {
              if (event.docuCourseCase) {
                event.docuCourseCase = event.docuCourseCase.filter(caseItem => !!caseItem)
              }
            })
            this.$set(this.slotDateArr, dateKey, item)
            if (this.slotDateArr[curTimeTxt] && this.slotDateArr[curTimeTxt].length > 0) {
              const startDayOfWeek = this.$moment(`${this.year}-${this.padZero(this.month)}`).day()
              let curday = this.curDay * 1 + startDayOfWeek
              this.defaultIndex = curday % 7 > 0 ? parseInt(curday / 7) : parseInt(curday / 7) - 1
            }
          })
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },

    formatDate (year, month, day) {
      return `${year}-${this.padZero(month)}-${this.padZero(day)}`
    },

    padZero (value) {
      return `${value}`.padStart(2, '0')
    },

    async handleMonthJian () {
      this.updateMonth(-1)
      this.isDayChanged = true
      await this.handleGetfun()
      this.isDayChanged = false
    },

    async handleMonthJia () {
      this.updateMonth(1)
      this.isDayChanged = true
      await this.handleGetfun()
      this.isDayChanged = false
    },

    updateMonth (delta) {
      this.month = Number(this.month) + delta
      if (this.month <= 0) {
        this.month = 12
        this.year--
      } else if (this.month >= 13) {
        this.month = 1
        this.year++
      }
    },
    getYearsAroundCurrentYear (range = 50) {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let i = -range; i <= range; i++) {
        years.push(currentYear + i)
        this.colum_index = 0 + i
      }
      this.columns = years
    },
    onCancel () {
      this.showChangeYear = false
    },
    async onConfirm (e) {
      this.year = e
      this.defaultIndex = null
      this.showChangeYear = false
      await this.handleGetfun()
    },

    getCurEvents () {
      return this.slotDateArr[this.formatDate(this.year, this.month, this.curDay)] || []
    },
    handleClickDate (day, weekIndex) {
      let premonth = this.month
      this.year = new Date(day).getFullYear()
      this.month = `${new Date(day).getMonth() + 1}`.padStart(2, '0')
      this.curDay = new Date(day).getDate() > 9 ? new Date(day).getDate() : `0${new Date(day).getDate()}`
      if (premonth !== this.month && !this.isDayChanged) {
        this.defaultIndex = null
        this.handleGetfun()
      } else {
        if (this.slotDateArr[day].length > 0) {
          this.defaultIndex = weekIndex
        } else {
          this.defaultIndex = null
        }
      }
    },
    handleGoto (item) {
      if (!item.classWeekUnlock) {
        this.$toast('班级课程暂未开始！')
        return
      }
      this.courseId = item.baseId
      this.journeyId = item.journeyId
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleGotoDetails()
    },
    async handleGotoDetails () {
      const query = {
        courseId: this.courseId,
        journeyId: this.journeyId,
        businessId: this.journeyId
      }
      const isscorm = await isScorm(this.courseId)
      let path = '/courserDetails'
      if (isscorm.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({path, query})
    },

    handleDelSave (item) {
      if (this.dialogConType === 'gradeQuestion') {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
            noneHasResult: true
          }
        })
      }
    },
    handleGoAnswer(item) {
      sessionStorage.setItem('traceObj', JSON.stringify({
        functionUrl: '/gradeQuestion',
        note: `postId=${item.id}&classId=${this.classId}`
      }))
      if (item.userInspectBusiness) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
          }
        })
      } else if (item.userInspectComplete) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
            noneHasResult: true
          }
        })
      } else {
        this.dialogHeadTxt = '进入考试'
        const str = item.userResidueInspectNum >= 0 ? `, 还剩<span style="color: #EB1700;">${item.userResidueInspectNum}</span>次！` : ''
        this.delMessage = `您好，您本场考试的答题次数为第${item.userInspectNum}次${str}`
        this.$refs.dialogDel.init(item)
        this.dialogConType = 'gradeQuestion'
      }
    },
  }

}
</script>
<style lang="less" scoped>
.calendars {
  background-color: #fff;
  position: relative;

  .calendars-top {
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    height: 56px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 14px;
    color: #282828;

    .top-years {
      margin-right: 32px;
      display: flex;
      align-items: center;

      .icon {
        width: 7px;
        display: block;
        margin-left: 8px;

        &.icon-left {
          transform: rotate(90deg);
          margin-right: 16px;
        }

        &.icon-right {
          transform: rotate(-90deg);
          margin-left: 16px;
        }
      }
    }
  }

  .tags {
    display: flex;
    flex-direction: column;

    .tag-txt {
      width: 100%;
      height: 20px;
      line-height: 20px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 10px;
      color: #000000;
      border-radius: 2px;
      margin-bottom: 3px;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }

      &.tags0 {
        background: #F0F0F0;
        color: rgba(0, 0, 0, 0.35);
        position: relative;
        padding-left: 6px;
        box-sizing: border-box;

        &::before {
          position: absolute;
          content: '+';
          left: 44%;
          top: -0.5px;
          transform: translateX(-50%);
        }
      }

      &.tag-txt1 {
        background-color: #E7F4DE;
      }

      &.tag-txt4 {
        &.tags6 {
          background-color: #FFFAB6;
        }

        &.tags7 {
          background-color: #B6D1F8;
        }

        &.tags8 {
          background-color: #E1D7FC;
        }

        &.tags9 {
          background-color: #FFA79D;
        }

        &.tags10 {
          background-color: #BAB6FF;
        }
      }

      &.tag-txt5 {
        background-color: #B6F8F8;
      }

      &.tag-txt6 {
        background-color: #F8CFE6;
      }

      &.tag-txt7 {
        background-color: #FFD2C9;
      }

      &.tag-txt8 {
        background-color: #BCDEB8;
      }

      &.tag-txt9 {
        background-color: #E1D7FC;
      }

      &.tag-txt10 {
        background-color: #FADA81;
      }
    }
  }

  .current-more-info {
    background: rgba(235, 23, 0, 0.08);
    color: #fff;
    display: flex;
    justify-content: center;
    padding: 8px 7px;
    box-sizing: border-box;
    width: 100vw;
    margin-left: -6px;
  }

  .more-info {
    background-color: #fff;
    border-radius: 8px;
    width: 100%;

    .tag-txt {
      height: 28px;
      line-height: 28px;
      border: 1px solid rgba(0, 0, 0, 0.05);
      padding: 0 10px;
      box-sizing: border-box;
      font-family: Lato, Lato;
      font-size: 11px;
      color: #000000;
    }

    .info-list {
      padding: 8px;
      box-sizing: border-box;

      .info-item {
        display: flex;
        margin-bottom: 8px;

        .item-tags {
          min-width: 46px;
          height: 16px;
          border-radius: 3px;
          margin-right: 4px;
          font-family: Helvetica, Helvetica;
          font-size: 10px;
          color: #000000;
          text-align: center;
          line-height: 16px;
          margin-top: 2px;

          &.tag-txt1 {
            background-color: #E7F4DE;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          &.tag-txt4 {
            &.tags6 {
              background-color: #FFFAB6;
            }

            &.tags7 {
              background-color: #B6D1F8;
            }

            &.tags8 {
              background-color: #E1D7FC;
            }

            &.tags9 {
              background-color: #FFA79D;
            }

            &.tags10 {
              background-color: #BAB6FF;
            }
          }

          &.tag-txt5 {
            background-color: #B6F8F8;
          }

          &.tag-txt6 {
            background-color: #F8CFE6;
          }

          &.tag-txt7 {
            background-color: #FFD2C9;
          }

          &.tag-txt8 {
            background-color: #BCDEB8;
          }

          &.tag-txt9 {
            background-color: #E1D7FC;
          }

          &.tag-txt10 {
            background-color: #FADA81;
          }
        }

        .item-cons {
          .cons-txt {
            font-family: PingFang HK, PingFang HK;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 280px;
            display: flex;
            align-items: center;

            &.cons-txt-question {
              justify-content: space-between;

              .go-btn {
                padding: 2px 10px;
                background-color: #EB1700;
                border-radius: 100px;
                color: #fff;
                font-size: 12px;
                font-family: Source Han Sans CN, Source Han Sans CN;
              }
            }

            &.con-txt2 {
              margin-bottom: 8px;

              &.cont-btm {
                margin-bottom: 4px;
              }

              .icon-suo {
                width: 12px;
                padding: 4px;
                display: block;
              }

              .con-idx {
                max-width: 290px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .itm-right {
                width: 8px;
                margin-left: 6px;
              }
            }
          }

          .cons-times {
            font-family: PingFang HK, PingFang HK;
            font-size: 12px;
            line-height: 20px;
            color: rgba(0, 0, 0, 0.5);

            .class-txt {
              margin-left: 8px;
            }
          }
        }
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/grade/components/date.vue